const teamMembers = [
  'Lucas Amaral',
  'Matheus Mesquita',
  'Bernardo Couto',
  'Vinicius Souza',
  'Thiago Carvalho',
  'Igor Jesus',
  'Alex Hofmann',
  'Leonardo Polon'
];

export default () => {
  const key = Math.floor(Math.random() * (teamMembers.length - 0.1));
  return teamMembers[key];
};
